module.exports = __webpack_public_path__ + "static/media/unimed-fesp.63503fb1.png";